import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  { q: "How fast do I actually get my content?", a: "72–96 hours from the time you complete the intake form, depending on the size of your project. Not 'business days.' Actual hours." },
  { q: "Can I cancel my monthly plan?", a: "Yes. Cancel anytime from the contact page or just email us. No fees, no penalties, no awkward retention call." },
  { q: "Do I need to provide footage or photos?", a: "No. We create everything from scratch using brand-safe stock + custom design based on your intake form." },
  { q: "What if I don't like the content?", a: "We'll revise it. Tell us what you want changed and we'll send a new batch within 72–96 hours." },
  { q: "Is this really only $99.99? What's the catch?", a: "There's no catch. Our process is so streamlined we can deliver great content without charging agency prices. We make money on volume." },
  { q: "How is the content delivered?", a: "Google Drive link. Download, post, repeat. Videos as MP4, images as high-res PNGs and JPGs." },
];

export const FAQ = () => {
  return (
    <section className="py-20 md:py-28" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <div className="text-center">
          <span className="pill" data-testid="faq-pill">Got Questions?</span>
          <h2 className="mt-5 font-display font-bold text-white text-4xl sm:text-5xl tracking-tighter">
            Answers. <span className="text-[#3B9EFF]">Not fluff.</span>
          </h2>
        </div>
        <Accordion type="single" collapsible className="mt-10">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-b border-[#3B9EFF]/15"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-white hover:no-underline font-display font-semibold text-lg py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#A0AABF] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
